// Generated by littlecrumb. Do not edit.
import type { ComponentType } from "react";
import type { RouteObject } from "react-router-dom";

type PageModule = {
  default: ComponentType;
  loader?: RouteObject["loader"];
  action?: RouteObject["action"];
  ErrorBoundary?: ComponentType;
};

function adapt(module: PageModule) {
  return {
    Component: module.default,
    loader: module.loader,
    action: module.action,
    ErrorBoundary: module.ErrorBoundary,
  };
}

export const routes: RouteObject[] = [
  {
    path: "/docs",
    lazy: async () => adapt(await import("../app/docs/page.tsx")),
  },
  {
    path: "/",
    lazy: async () => adapt(await import("../app/page.tsx")),
  }
];
